var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('boiler-room-header',{staticClass:"header"}),_c('div',{staticClass:"contents"},[_c('boiler-room-tabs',{attrs:{"boiler-room":_vm.boilerRoom}}),_c('boiler-room-links',{staticClass:"footer"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }